import { disablePageScroll, enableScroll } from '../utils/scroll';

export default () => {
  document.querySelectorAll('.filter').forEach((filter) => {
    const mobileBtn = filter.querySelector('.filter__mobile-btn');
    const menuWrapper = filter.querySelector('.news__menu-wrapper');
    const overlay = filter.querySelector('.filter__overlay');
    const filterBtns = filter.querySelectorAll('.filter__btn');
    const submit = filter.querySelector('.filter__submit');

    function openMobileFilter() {
      menuWrapper.classList.add('visible');
      document.body.classList.add('filter-opened');
      disablePageScroll(true);
    }

    function closeMobileFilter() {
      menuWrapper.classList.remove('visible');
      document.body.classList.remove('filter-opened');
      enableScroll();

      filterBtns.forEach((filterBtn) => {
        filterBtn.classList.remove('selected');
        filterBtn.classList.remove('not-selected');
      });
    }

    mobileBtn.addEventListener('click', (event) => {
      event.preventDefault();
      openMobileFilter();
    });

    submit.addEventListener('click', (event) => {
      event.preventDefault();
      const selectedBtns = [...filterBtns].filter((btn) => btn.classList.contains('selected') || btn.classList.contains('active') && !btn.classList.contains('not-selected'));

      if (selectedBtns.length) {
        window.location.search = '?' + selectedBtns.map(btn => `${btn.getAttribute('data-url-var')}=${btn.getAttribute('data-slug')}`).join('&');
      } else {
        window.location.search = '';
      }

      closeMobileFilter();
    });

    overlay.addEventListener('click', () => {
      closeMobileFilter();
    });

    filterBtns.forEach((filterBtn) => {
      filterBtn.addEventListener('click', (event) => {
        if (window.innerWidth > 998) return;
        event.preventDefault();

        const group = filterBtn.closest('.filter__group');
        const groupBtns = group.querySelectorAll('.filter__btn');

        groupBtns.forEach((btn) => {
          if (btn === filterBtn) return;
          if (btn.classList.contains('active')) {
            btn.classList.add('not-selected');
          } else {
            btn.classList.remove('selected');
          }
        });

        if (filterBtn.classList.contains('active')) {
          filterBtn.classList.toggle('not-selected');
        } else {
          filterBtn.classList.toggle('selected');
        }
      });
    });

    window.addEventListener('widthResize', () => {
      closeMobileFilter();
    });

  });
};
